import { useContractorGroupsByIDs } from "@src/data-hooks/contractor-group/contractorGroup.service";
import { useProperty } from "@src/data-hooks/property/property.service";
import { SelectInputData, SelectInputField } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { ContractorGroupData } from "../../../ContractorGroup/ContractorGroupData";
import { LocalData } from "../../../General/LocalData";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";

export class CustomFieldContractorDataType extends CustomFieldDataTypeHelper<ContractorGroupData[]> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setRawData: (data: string[] | undefined) => void
  ): JSX.Element {
    return <CustomFieldContractorDataTypeEditor data={data} context={context} setRawData={setRawData} />;
  }

  getStringRepresentation(data: any, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    const contractors: ContractorGroupData[] = [];
    if (Array.isArray(data)) {
      for (const id of data) {
        if (typeof id === "string") {
          contractors.push(LocalData.contractorGroups.addData(id));
        }
      }
    } else if (typeof data === "string") {
      contractors.push(LocalData.contractorGroups.addData(data));
    }

    if (contractors.some((data) => !data.loaded)) {
      return Promise.all(contractors.filter((tenant) => !tenant.loaded).map((tenant) => tenant.load()))
        .then(() => {
          return contractors.map((data) => data.name).join(", ");
        })
        .catch(() => {
          return contractors.map((data) => data.name).join(", ");
        });
    }

    return contractors.map((data) => data.name).join(", ");
  }
}

type CustomFieldContractorDataTypeProps = {
  data: any | undefined;
  context: DataEditorContext;
  setRawData: (data: string[] | undefined) => void;
};

const CustomFieldContractorDataTypeEditor = ({ data, context, setRawData }: CustomFieldContractorDataTypeProps) => {
  const { property } = useProperty(context.propertyID);
  const { contractorGroups } = useContractorGroupsByIDs(property?.contractorGroups ?? []);

  return (
    <SelectInputField
      width="100%"
      multi
      options={contractorGroups.map((contractor) => new SelectInputData(contractor.id, contractor.name))}
      value={Array.isArray(data) ? data.map((id) => id) : undefined}
      onChange={(selected) => {
        if (Array.isArray(selected)) {
          setRawData((selected as SelectInputData[]).map((data) => data.value));
        } else {
          setRawData([]);
        }
      }}
      menuPortalTarget={context.menuPortalTarget}
    />
  );
};
